module.exports = __webpack_public_path__ + "img/order3.5332fd97.png";